
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import VEmptyState from '@/components/shared/VEmptyState.vue';
import ReleasesFilter from '@/components/releases/ReleasesFilter.vue';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { Release } from '@/interfaces/models/Release';
import { Venue } from '@/interfaces/models/Venue';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import headers from './headers';

@Component({
  components: { VTable, VEmptyState, ReleasesFilter },
})
export default class ReleasesTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Release[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public customerGroups!: CustomerGroupEnum[];
  @Prop({ type: Boolean, required: true }) public canEdit!: boolean;
  @Prop({ type: Boolean, required: true }) public canDelete!: boolean;
  @Prop({ type: Object, required: false }) public venue!: Venue;

  public headers: ColumnHeader[] = headers;
}
